import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'hooks';
import { selectedAccountSelector } from '../../../selectors';
import { generatePerformanceRecommendationsReviewerPath } from '../services/utils';

const useOpenPerformanceRecommendationsReviewer = () => {
    const { accountId: selectedAccountId } = useSelector(selectedAccountSelector);
    const navigate = useNavigate();

    return useCallback(
        campaign => {
            const { id, accountName, advertiserName } = campaign;
            // TODO: remove advertiserName after DEV-65984
            const resolvedAdvertiserName = accountName || advertiserName || selectedAccountId;
            const editCampaignsGroupPath = generatePerformanceRecommendationsReviewerPath({
                accountId: resolvedAdvertiserName,
                campaignId: id,
            });
            navigate(editCampaignsGroupPath);
        },
        [selectedAccountId, navigate]
    );
};

export default useOpenPerformanceRecommendationsReviewer;
